import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ManagersBusinessSectionsNewType } from "~/domains";

const request = async (): Promise<ManagersBusinessSectionsNewType> => {
  const response = await new ApiClient().get<ManagersBusinessSectionsNewType>(
    "/api/managers/business_sections/new",
  );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersBusinessSectionsNew = ({
  config = {},
}: PropsType = {}): UseQueryResult<ManagersBusinessSectionsNewType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersBusinessSectionsNew"],
    queryFn: request,
  });
};
